import React from 'react';
import { Provider } from 'react-redux';
import { TPAComponentsProvider } from 'wix-ui-tpa';
import WidgetDesktop from './widget';
import WidgetMobile from './mobile/widgetMobile';
import wixService from '../../services/wixService';

import { compId } from '../../actions/utils';
import Loader from '../common/Loader/Loader';
import createWidgetStore from './store/createWidgetStore';

import triggerEvent from '../../services/bi/biSiteLogger';
import biData from '../../services/bi/biEvents.json';
 import WidgetX from './widgetX';
// import settings from '../settings/components/modules/settings/settings';

export default class WidgetRoot extends React.Component {
  constructor(props) {
    super(props);
    window.Wix.Performance.applicationLoaded();
    this.initialState = window.initialState;
    this.initialState.compId = compId;
    this.state = {
      isRTL:
        this.initialState.settings.textAlignment ===
        this.initialState.constants.ALIGNMENT.RIGHT,
      settings: this.initialState.settings,
      loaded: false,
      isExperiment: false,
      isEditorXOrStudio :false,
    };
    // this.initExperiment();
  }

  componentDidMount() {
    try {
      const self = this;
      this.store = createWidgetStore(this.initialState);
      self.setState({ loaded: true });
      wixService.Styles.getStyleParams((style) => {
        window.Wix.Performance.applicationLoadingStep(40);
        self.setState({ loaded: true,isEditorXOrStudio:style?.booleans?.responsive });
      });
      triggerEvent(biData.APP_START_LOADING);
    } catch (err) {}
  }

  render() {
    const isMobile = wixService.isMobile();

    const { loaded , isEditorXOrStudio} = this.state;
    // This would be completely optional, but I would show some form of loading icon or text whilst you wait for the API to fetch the data.
    if (!loaded) {
      return <Loader />;
    }

    // If all is well, the component should render the store with the correct initialState
    else {
      return (
       <Provider store={this.store}>
          <TPAComponentsProvider
            value={{ mobile: isMobile, rtl: this.state.isRTL }}
          >
            {isMobile ? (
              <WidgetMobile {...this.props} />):
              //   isEditorXOrStudio? <WidgetX {...this.props} />:
               <WidgetDesktop {...this.props} /> }
          </TPAComponentsProvider>
        </Provider>
      );
    }
  }
}
